import { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import {
  faCaretDown,
  faCaretUp,
  faCircleCheck,
  faEye,
  faMinusCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import useAuth from "../../../Pages/hooks/useAuth";
import {
  ACADIMAC,
  baseURL,
  DELETEUSER,
  PAN,
  UNBAN,
  USERDASHBORD,
} from "../../../API/API";
import { BsBook, BsExclamationTriangleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { FaCity, FaEnvelope, FaPhone, FaSchool, FaUser } from "react-icons/fa6";
import { toast } from "react-toastify";

export default function Users() {
  const { auth } = useAuth();
  let role = auth?.user?.role;
  if (!role || role === 'student') {
    if (auth?.user?.email === 'admin@academy.com' || auth?.user?.email === 'admin@example.com') {
      role = 'admin';
    } else if (auth?.user?.is_staff) {
      role = 'teacher';
    } else {
      role = 'student';
    }
  }
  const isAdmin = role === 'admin';
  const [academicYears, setAcademicYears] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [Order, setOrder] = useState("username");
  const [OrderType, setOrderType] = useState(false);
  const [TypeStudent, setTypeStudent] = useState("-");
  const [post, setpost] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkAction, setBulkAction] = useState("");
  const [showmessage, setShowMessage] = useState(false);
  const [rowId, setrowId] = useState([]);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Academacs, setAcademacs] = useState([]);
  const [studentStatus, setStudentStatus] = useState("-");
  const fetchData = useCallback(async () => {
    try {
      const res = await axiosPrivate.post(`${baseURL}/${USERDASHBORD}/`, {
        Order,
        OrderType,
        TypeStudent,
        post,
        indexpage,
        PanFilter: studentStatus,
      });

      console.log("Users Data:", res.data);
      setAcademicYears(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error("خطأ في جلب المستخدمين:", err);
      setAcademicYears([]);
    }
  }, [axiosPrivate, Order, OrderType, TypeStudent, post, indexpage, studentStatus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    async function featchmonth() {
      const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);
      setAcademacs(res.data.data);
    }

    featchmonth();
  }, [axiosPrivate]);

  //1/ delete items
  async function deleteItems(selectedIds) {
    try {
      const res = await axiosPrivate.delete(`${baseURL}/${DELETEUSER}/`, {
        data: { ids: selectedIds },
      });
      fetchData();
    } catch (err) {
      console.log(err);
    }
  }

  //1/ في الـ state
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedContactMsg, setSelectedContactMsg] = useState(null);

  const handleShowModal = (rowData) => {
    setSelectedContactMsg(rowData);
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setSelectedContactMsg(null);
  };

  async function togglePan(id, pan) {
    try {
      const endpoint = pan ? PAN : UNBAN;
      console.log('📤 Ban Request:', { endpoint, id, baseURL });
      const response = await axiosPrivate.put(`${baseURL}/${endpoint}/`, {
        id,
      });
      console.log('📥 Ban Response:', response.data, 'Status:', response.status);
      
      if (response.status === 200 || response.data.Message === 'OK') {
        const message = pan ? '✅ تم حظر الطالب بنجاح' : '✅ تم فك الحظر عن الطالب بنجاح';
        toast.success(message);
        console.log('🔄 Fetching updated data after ban...');
        fetchData();
      }
    } catch (error) {
      console.error("❌ Error toggling pan:", error);
      console.error('Error Response:', error?.response?.data);
      const errorMsg = error?.response?.data?.message || 
                       error?.response?.data?.Message || 
                       (error.response?.status === 404 ? 'الطالب غير موجود' : 'فشل تنفيذ العملية');
      toast.error("❌ " + errorMsg);
    }
  }

  const [showBanModal, setShowBanModal] = useState(false);
  const [banTarget, setBanTarget] = useState(null); //1/ id وحالته الجديدة

  function handleBanClick(id, newStatus) {
    setBanTarget({ id, status: newStatus });
    setShowBanModal(true);
  }

  async function confirmBanAction() {
    if (banTarget) {
      await togglePan(banTarget.id, banTarget.status);
    }
    setShowBanModal(false);
    setBanTarget(null);
  }

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center mb-5">
        <h4 className="fw-bold"> المستخدمين</h4>
      </div>

      {/* Filters */}
      <div className="d-flex mb-3 gap-2 flex-wrap">
        {isAdmin && (
          <>
            <Form.Select
              style={{ maxWidth: "240px" }}
              onChange={(e) => setBulkAction(e.target.value)}
            >
              <option value="">تنفيذ على العناصر المحددة</option>
              <option value="delete">حذف</option>
            </Form.Select>

            <Button
              className="custom-brand-btn-dhash"
              variant="secondary"
              onClick={() => {
                if (selectedItems.length > 0) {
                  setShowMessage(true);
                }
              }}
            >
              تطبيق
            </Button>
          </>
        )}

        <Form.Select
          style={{ maxWidth: "150px" }}
          onChange={(e) => setStudentStatus(e.target.value)}
        >
          <option value="-"> حالة الطالب </option>
          <option value={true}>مقيد</option>
          <option value={false}>غير مقيد</option>
        </Form.Select>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              {/* UP and down */}
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span>الاسم</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "username");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "username");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <span>البريد </span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "email");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "email");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> رقم الهاتف </span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "phoneNumber");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "phoneNumber");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> المحافضة</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "governorate");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "governorate");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> المدرسة</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "schoolName");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "schoolName");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> السنة الدراسية</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "academicYear");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "academicYear");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              {isAdmin && <th>اشترك مع مين</th>}
              <th>أدوات</th>

              {isAdmin && <th>*</th>}
            </tr>
          </thead>
          <tbody>
            {academicYears.map((row, index) => (
              <tr key={index}>
                {row.isBan ? (
                  <td style={{ color: "red" }}>{row.username}</td>
                ) : (
                  <td>{row.username}</td>
                )}

                {row.isBan ? (
                  <td style={{ color: "red" }}>{row.email}</td>
                ) : (
                  <td>{row.email}</td>
                )}

                {row.isBan ? (
                  <td style={{ color: "red" }}>{row.phoneNumber}</td>
                ) : (
                  <td>{row.phoneNumber}</td>
                )}

                {row.isBan ? (
                  <td style={{ color: "red" }}>{row.governorate}</td>
                ) : (
                  <td>{row.governorate}</td>
                )}

                {row.isBan ? (
                  <td style={{ color: "red" }}>{row.schoolName}</td>
                ) : (
                  <td>{row.schoolName}</td>
                )}

                {row.isBan ? (
                  <td style={{ color: "red" }}>{row.academicYear}</td>
                ) : (
                  <td>{row.academicYear}</td>
                )}

                {isAdmin && (
                  row.isBan ? (
                    <td style={{ color: "red" }}>{row.subscribed_teachers || "لا يوجد"}</td>
                  ) : (
                    <td>{row.subscribed_teachers || "لا يوجد"}</td>
                  )
                )}

                <td className="d-flex justify-content-center gap-2">
                  {isAdmin && (
                    <>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {!row.isBan ? "إلغاء الإيقاف" : "إيقاف الحساب"}
                          </Tooltip>
                        }
                      >
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => handleBanClick(row.id, !row.isBan)}
                        >
                          {!row.isBan ? (
                            <FontAwesomeIcon
                              icon={faCircleCheck}
                              style={{ color: "green" }}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faMinusCircle}
                              style={{ color: "var(--nat-400)" }}
                            />
                          )}
                        </Button>
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>حذف</Tooltip>}
                      >
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => {
                            setrowId([row.id]);
                            setShowMessage(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </OverlayTrigger>
                    </>
                  )}

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>عرض</Tooltip>}
                  >
                    <Button
                      onClick={() => handleShowModal(row)} //1/ هنا بنبعت بيانات الصف
                      size="sm"
                      variant="outline-info"
                    >
                      <FontAwesomeIcon
                        icon={faEye}
                        style={{ color: "#17A2B8" }}
                      />
                    </Button>
                  </OverlayTrigger>
                </td>
                {isAdmin && (
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedItems.includes(row.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedItems((prev) => [...prev, row.id]);
                        } else {
                          setSelectedItems((prev) =>
                            prev.filter((id) => id !== row.id)
                          );
                        }
                      }}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Pagination
        className="justify-content-center custom-pagination"
        dir="ltr"
      >
        <Pagination.Prev
          onClick={() => {
            if (indexpage > 1) setindexPage(indexpage - 1);
          }}
          disabled={indexpage === 1}
        />

        {[...Array(totalPages).keys()]
          .map((n) => n + 1)
          .filter(
            (page) =>
              page === 1 ||
              page === totalPages ||
              (page >= indexpage - 2 && page <= indexpage + 2)
          )
          .map((page, i, arr) => {
            const prevPage = arr[i - 1];
            if (prevPage && page - prevPage > 1) {
              return [
                <Pagination.Ellipsis key={`ellipsis-${page}`} disabled />,
                <Pagination.Item
                  key={page}
                  active={indexpage === page}
                  onClick={() => setindexPage(page)}
                >
                  {page}
                </Pagination.Item>,
              ];
            }

            return (
              <Pagination.Item
                key={page}
                active={indexpage === page}
                onClick={() => setindexPage(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

        <Pagination.Next
          onClick={() => {
            if (indexpage < totalPages) setindexPage(indexpage + 1);
          }}
          disabled={indexpage === totalPages}
        />
      </Pagination>

      {showBanModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              {banTarget?.status
                ? "هل أنت متأكد أنك تريد إيقاف هذا الحساب"
                : "هل أنت متأكد أنك تريد فك إيقاف هذا الحساب"}
            </h2>
            <p>
              <span>
                {banTarget?.status
                  ? "بعد تنفيذ هذا الإجراء، لن يتمكن المستخدم من تسجيل الدخول أو استخدام خدمات الموقع."
                  : "سيتمكن المستخدم من تسجيل الدخول واستخدام خدمات الموقع مجددًا."}
              </span>
            </p>

            <div className="d-flex justify-content-start gap-3">
              <button
                className="btn btn-outline-danger mt-3"
                onClick={confirmBanAction}
              >
                تأكيد
              </button>

              <button
                className="btn btn-outline-secondary mt-3"
                onClick={() => setShowBanModal(false)}
              >
                إغلاق
              </button>
            </div>
          </div>
        </div>
      )}

      {showmessage && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              ستقوم بحذف العناصر المحددة
            </h2>
            <div>
              <p>لن تتمكن من التراجع عن هذا الإجراء.</p>
              <p></p>
            </div>

            <div className="d-flex justify-content-start gap-3 ">
              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  if (rowId.length > 0) {
                    deleteItems(rowId);
                    setrowId([]);
                  }

                  setShowMessage(false);
                  if (bulkAction === "delete") {
                    deleteItems(selectedItems);
                  }
                }}
              >
                تاكيد الحذف
              </button>

              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  setShowMessage(false);
                }}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        show={showContactModal}
        onHide={handleCloseContactModal}
        centered
        dir="ltr"
      >
        <Modal.Header className="position-relative border-0">
          <Modal.Title className="fw-bold fs-5">بيانات الطالب</Modal.Title>

          <Button
            variant="danger"
            onClick={handleCloseContactModal}
            className="position-absolute top-0 end-0 me-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "32px",
              height: "32px",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            ×
          </Button>
        </Modal.Header>
        <Modal.Body>
          {selectedContactMsg ? (
            <div
              className="p-3 border rounded bg-light"
              style={{ lineHeight: "2", direction: "rtl" }}
            >
              <p>
                <strong>
                  <FaUser size={20} className="me-2" /> الاسم:
                </strong>{" "}
                {selectedContactMsg.username}
              </p>
              <p>
                <strong>
                  <FaEnvelope size={20} className="me-2" /> البريد الالكتروني :
                </strong>{" "}
                {selectedContactMsg.email || "غير متوفر"}
              </p>
              <p>
                <strong>
                  <FaPhone size={20} className="me-2" /> رقم هاتف الطالب:
                </strong>{" "}
                {selectedContactMsg.phoneNumber || "غير متوفر"}
              </p>
              <p>
                <strong>
                  <FaPhone size={20} className="me-2" /> رقم هاتف ولي الامر:
                </strong>{" "}
                {selectedContactMsg.parentPhone || "غير متوفر"}
              </p>
              <p>
                <strong>
                  <FaCity size={20} className="me-2" /> الحافظه:
                </strong>{" "}
                {selectedContactMsg.governorate || "غير متوفر"}
              </p>
              <p>
                <strong>
                  <FaSchool size={20} className="me-2" /> مدرسه:
                </strong>{" "}
                {selectedContactMsg.schoolName || "غير متوفر"}
              </p>
              <p>
                <strong>
                  <BsBook size={20} className="me-2" /> السنه الدراسيه:
                </strong>{" "}
                {selectedContactMsg.academicYear || "غير متوفر"}
              </p>
            </div>
          ) : (
            <div className="text-center text-muted p-4">
              لا توجد بيانات لعرضها حاليًا
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
